import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Silk from 'modules/Common/components/Silk';

require("./HorseRacingRacecardRunner.scss");

export default class HorseRacingRacecardNonRunner extends Component {

  constructor(props) {
    super(props);
  }

  render(){
    const {
      nonRunner : nonRunner
    } = this.props;

    return (
      <section className="hr-racing-nonrunner-wrapper">
        <div className="hr-racing-nonrunner-key-info-container">
          <div className="hr-racing-nonrunner-saddle-stall-info">
            <div className="row">
              <span className="hr-racing-nonrunner-saddle-cloth-no">{nonRunner.saddleClothNo}</span>
            </div>
            <div className="row">
              <span className="hr-racing-nonrunner-stall-no">{nonRunner.drawNumber}</span>
            </div>
          </div>
          <div className="hr-racing-nonrunner-silks">
            <Silk filename={nonRunner.silkFilename}/>
          </div>
          <div className="hr-racing-nonrunner-horse-info">
            <div className="row">
              <span className="hr-racing-nonrunner-horse-name">{nonRunner.horseName}
                <sup className="hr-racing-nonrunner-horse-last-ran">{nonRunner.horseLastRan}</sup>
              </span>
            </div>
            <div className="row">
              <div className="hr-racing-nonrunner-horse-sub-info">
                { nonRunner.horseAge && <span>{nonRunner.horseAge}</span> }
                { nonRunner.weight && <span>{nonRunner.weight}</span> }
                <span>OR:&nbsp;{nonRunner.officialRating ? nonRunner.officialRating : '-'}</span>
              </div>
            </div>
          </div>
          <div className="hr-racing-nonrunner-betting-odds">
            <button className="hr-racing-nonrunner-betting-button disabled">{ nonRunner.status === 'WITHDRAWN' ? 'WD' : 'NR' }</button>
          </div>
        </div>
        <div className="hr-racing-nonrunner-form-history-container">
          <div className="hr-racing-nonrunner-form-key-info">
            <span className="hr-racing-nonrunner-form-trainer">T:&nbsp;<span>{nonRunner.trainer.name}</span></span>
            <span className="hr-racing-nonrunner-form-jockey">J:&nbsp;<span>{nonRunner.jockey.name}</span></span>
          </div>
        </div>
      </section>
    );
  }
}

HorseRacingRacecardNonRunner.propTypes = {
  nonRunner: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardNonRunner.js